<ng-container *ngVar="(workflowitemRD$ | async)?.payload as workflowitem">
  <ds-themed-item-list-preview *ngIf="workflowitem"
                        [item]="(workflowitem?.item | async)?.payload"
                        [object]="object"
                        [showSubmitter]="showSubmitter"
                        [status]="status"></ds-themed-item-list-preview>
  <ds-pool-task-actions id="actions" *ngIf="workflowitem" [object]="dso" (processCompleted)="this.reloadedObject.emit($event.reloadedObject)"></ds-pool-task-actions>
</ng-container>
